import { memo } from "react";

import type { ClarificationOption } from "@/feature/ai-planner/lib/chat-message.utils";
import { cn } from "@/lib/utils";

export const ClarificationOptions = memo(function ClarificationOptions({
  options,
}: {
  options: ClarificationOption[];
}) {
  if (!options.length) {
    return null;
  }

  const visibleOption = options.at(-1);
  if (!visibleOption) {
    return null;
  }

  return (
    <div className="mt-3 space-y-2">
      <div
        key={`${visibleOption.code}-${visibleOption.title}`}
        className={cn(
          "rounded-2xl border border-border/70 bg-muted/30 px-3 py-2.5",
          "overflow-hidden",
        )}
      >
        <div className="flex flex-wrap items-start gap-2">
          <span className="rounded-full bg-background px-2 py-0.5 text-[11px] font-semibold tracking-[0.08em] text-foreground">
            {visibleOption.code}
          </span>
          <div className="min-w-0 flex-1">
            <p className="break-words text-sm font-medium [overflow-wrap:anywhere]">
              {visibleOption.title}
            </p>
            {visibleOption.description ? (
              <p className="text-muted-foreground mt-1 text-xs leading-relaxed [overflow-wrap:anywhere]">
                {visibleOption.description}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
});
